import { useQuery } from "@tanstack/react-query";
import { api } from "../utils/api";

const getOrganizations = () => api.get('/organizations/').then(res => res.data);

export default function useOrganizations(props) {
  return useQuery({ queryKey: ['organizations'], queryFn: getOrganizations, ...props });
}
